import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { SequenceCommandCenter } from "@/components/app/sequence-command-center";

const description =
  "Track the contacts you enrolled in outreach sequences, see what is landing, and pause or stop a sequence.";

export const Route = createFileRoute("/_authenticated/sequences")({
  head: () => ({
    meta: [
      { title: "My sequences | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "My sequences | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SequencesPage,
});

function SequencesPage() {
  return (
    <AppShell title="Sequences" eyebrow="Inbox">
      <SequenceCommandCenter mode="mine" />
    </AppShell>
  );
}
